export default "__VITE_ASSET__XGD4V6Dt__"